module.exports = __webpack_public_path__ + "static/img/no-order.8b38af3f.png";